import EmptyScreen from "../../component/common/EmptyScreen";
import WaiterCard from "./WaiterCard";

function WaiterRequestMobile({ requestType, status }) {


  return (
    <div className="reservation-container">

      {requestType.length === 0 ? (
        <EmptyScreen message="No waiter request(s) found." />
      ) : (
        <>
          <ul className="reservation-list">
            {requestType.map((req) => (
              <WaiterCard
                key={req.restaurantTable?.tableName}
                res={req}
                status={status}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default WaiterRequestMobile;